import styled from 'styled-components';

export type IStyledPipaProductProps = {
  textColor: string;
};

export const StyledPipaMainProduct = styled.div<IStyledPipaProductProps>`
  display: flex;
  align-items: center;
  color: ${({ textColor }) => textColor};

  .stroked {
    margin: 0 0 0 4px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration: line-through;
    color: #fff;
    text-shadow: none;
  }
`;

export const StyledPipaSubProduct = styled.div<IStyledPipaProductProps>`
  display: flex;
  align-items: center;
  color: ${({ textColor }) => textColor};
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  .sub-image {
    width: 24px;
    height: 24px;
    margin-right: 4px;

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
